import { cloneDeep } from "lodash";

export const EditAttributeDialogMixin = {
  data() {
    return {
      dialog: {
        show: false,
        width: "640px",
        title: "",
        type: null,
        isLoading: false,
        isSaving: false,
        isPersistent: true,
      },
      editedItem: null,
      surfaceInfoResult: null,
    };
  },
  methods: {
    editAttribute(attribute) {
      if (!attribute.isWritable) return;
      this.editedItem = cloneDeep(attribute);

      this.dialog.type = "editAttribute";
      this.dialog.width = "640px";
      this.dialog.show = true;
    },
    changeAttribute(editedItem) {
      if (editedItem.pivot.clear == true) {
        editedItem.pivot.override = null;
      }
      this.editedItem = cloneDeep(editedItem);
      this.$emit("attributeUpdated", cloneDeep(this.editedItem));
      this.closeModal();
    },

    emitAttributeUpdated(element){
      this.$emit("attributeUpdated", cloneDeep(element));
      
    },

    closeModal(dialog) {
      if (dialog) {
        this.dialog = cloneDeep(dialog);
      } else {
        this.dialog = Object.assign(this.dialog, { show: false, isLoading: false });
      }

      this.surfaceInfoResult = null;
      this.editItem = null;
    },
  },
};
